import * as Yup from "yup";

export const SignUpIdSchema = Yup.object().shape({
	countryCode: Yup.number().required("Area code is required"),
	phoneNumber: Yup.number().required("Phone number is required"),
	extension: Yup.number().required("Phone number is required")
});
